import React, { useReducer } from 'react';
import { HistoricalSurveyResultsSet } from '@Models/HistoricalSurveyResultsSet';

type State = {
    historicalData: HistoricalSurveyResultsSet,
};

export type HistoricalDataAnalysisAction = {
    type: string;
}
export enum HistoricalDataAnalysisActionType {
}

const emptyState: State = {
    historicalData: new HistoricalSurveyResultsSet([])
}

type ContextType = State & {
    dispatch: React.Dispatch<HistoricalDataAnalysisAction>
};

export const HistoricalDataAnalysisContext = React.createContext<ContextType>({
    ...emptyState,
    dispatch: () => { }
});

function reducer(state: State, action: HistoricalDataAnalysisAction): State {
    switch (action.type) {
        default:
            return state;
    }
}

export function HistoricalDataAnalysisContextProvider(props: { children: JSX.Element[] | JSX.Element, initialState?: State }) {
    const [state, dispatch] = useReducer(reducer, props.initialState || emptyState);
    const value = { ...state, dispatch };
    return <HistoricalDataAnalysisContext.Provider value={value}>{props.children}</HistoricalDataAnalysisContext.Provider>;
}
